/* LOVE BOMB — letter from the envelope.

   Click (or Enter/Space, since the trigger is a real button) opens the
   envelope: the flap folds back and the letter springs out. Click again to put
   it away.

   Scroll still nudges the letter part-way out on its own, so the section is
   never inert for someone who does not think to click — but the click is what
   actually opens it, and once opened the letter stays out regardless of
   scrolling. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setup(stage) {
    var paper = stage.querySelector('[data-lb-letter-paper]');
    var toggle = stage.querySelector('[data-lb-letter-toggle]');
    if (!paper) return;

    // travel is a share of the LETTER's height, and the letter is far taller
    // on a phone, so the same percentage lifts it much further. Mobile has its
    // own, smaller value.
    var phone = window.matchMedia('(max-width: 749px)');

    function travelFor() {
      var attr = phone.matches ? 'data-travel-mobile' : 'data-travel';
      var v = parseFloat(stage.getAttribute(attr));
      return isNaN(v) ? (phone.matches ? 22 : 44) : v;
    }

    var travel = travelFor();
    var open = false;
    var ticking = false;
    var visible = false;

    function peek() {
      // how far the letter has crept out on scroll alone, before any click
      var r = stage.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var start = vh * 0.92;
      var end = vh * 0.35;
      var span = start - end;
      if (span <= 0) return 0;
      var p = (start - r.top) / span;
      p = p < 0 ? 0 : p > 1 ? 1 : p;
      // a third of the full travel: enough to show there is something inside
      return p * (travel / 3);
    }

    function render() {
      ticking = false;
      var amount = open ? travel : peek();
      paper.style.transform = 'translateY(' + -amount + '%)';
    }

    function onScroll() {
      if (ticking || !visible || open) return;
      ticking = true;
      window.requestAnimationFrame(render);
    }

    function setOpen(next) {
      open = next;
      stage.classList.toggle('is-open', open);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      render();
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        setOpen(!open);
      });
    }

    if (reduce.matches) {
      // CSS parks it open; nothing to drive
      return;
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          visible = entries[0].isIntersecting;
          if (visible) onScroll();
        },
        { rootMargin: '150px 0px' }
      ).observe(stage);
    } else {
      visible = true;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      travel = travelFor();
      visible = true;
      render();
    });

    requestAnimationFrame(render);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-lb-letter]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
